<template>
  <div>
    <div class="d-flex justify-space-between mb-4">
      <div>
        <div class="page-title mb-2">เพิ่มกิจกรรม</div>
      </div>
    </div>
    <divcard class="mt-5">
      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="font-20 font-w-700">
          ข้อมูลกิจกรรม
        </div>
        <div class="d-flex flex-column py-5">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อกิจกรรม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.name" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุชื่อกิจกรรม']" @onChange="setFormField('name', $event)" required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                วันที่เริ่ม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <DatePicker 
              :value="form.start_date" 
              :minDate="today" 
              placeholder="โปรดระบุ"
              @onInput="form.start_date = $event; $forceUpdate()" 
              :rules="[(v) => !!v || 'กรุณาระบุวันที่เริ่ม']"
              ></DatePicker>
            </div>
            <div class="flex">
              <div class="mb-1 black--text">
                จนถึง
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <DatePicker 
              :minDate="today" placeholder="โปรดระบุ" 
              :value="form.end_date"
              @onInput="form.end_date = $event; $forceUpdate()" 
              :rules="[(v) => !!v || 'กรุณาระบุวันที่สิ้นสุด']"
              ></DatePicker>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เวลาที่เริ่ม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TimePicker 
              :value="form.start_time" 
              placeholder="โปรดระบุ" 
              @onInput="form.start_time = $event; $forceUpdate()"
              :rules="[(v) => !!v || 'กรุณาระบุเวลาที่เริ่ม']"
              ></TimePicker>
            </div>
            <div class="flex">
              <div class="mb-1 black--text">
                จนถึง
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TimePicker 
              :value="form.end_time" 
              placeholder="โปรดระบุ" 
              @onInput="form.end_time = $event; $forceUpdate()"
              :rules="[(v) => !!v || 'กรุณาระบุเวลาสิ้นสุด']"
              ></TimePicker>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                สถานที่
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.location" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุสถานที่']" @onChange="setFormField('location', $event)" required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนบลิงค์
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.location_link" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุลิงค์']" @onChange="setFormField('location_link', $event)" required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                รายละเอียด
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextArea theme="3" v-model="form.description" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุรายละเอียด']" @onChange="setFormField('description', $event)"
                required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ผู้เข้าร่วม
              </div>
              <TextArea theme="3" v-model="form.participants" :placeholder="'1.\n2.\n3.'"
                @onChange="setFormField('participants', $event)" />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เบอร์โทร ผู้ประสานงาน
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.coordinator_phone" placeholder="โปรดระบุ"
                :rules="[
                  (v) => !!v || 'กรุณาระบุเบอร์โทร ผู้ประสานงาน',
                ]"
                @onChange="setFormField('coordinator_phone', $event)"
                required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ประธานกิจกรรม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.event_leader" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุประธานกิจกรรม']" @onChange="setFormField('event_leader', $event)"
                required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ผู้จัดกิจกรรม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.organizer" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุผู้จัดกิจกรรม']" @onChange="setFormField('organizer', $event)"
                required />
            </div>
          </div>
        </div>
      </v-form>
    </divcard>
    <div class="d-flex justify-space-between mt-10">
      <div>
        <Button theme="2" @onClick="routeBack">ยกเลิก</Button>
      </div>
      <div>
        <Button theme="1" @onClick="submitForm">บันทึก</Button>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from "@/components/input/TextField.vue";
import TextArea from "@/components/input/TextArea.vue";
import Button from "@/components/input/Button";
import DatePicker from "@/components/input/DatePicker.vue";
import TimePicker from "@/components/input/TimePicker.vue";


export default {
    name: 'CalendarActivityCreate',
    components: {
        TextField,
        Button,
        TextArea,
        DatePicker,
        TimePicker
    },
    data() {
        return {
            form: {
                start_date: "",
                end_date: "",
                start_time: "",
                end_time: "",
            },
            valid: true,
            today: null
        }
    },
    created() {
      this.today = new Date().toISOString().split("T")[0];
    },
    methods: {
        async submitForm() {
          if (this.$refs.form.validate()) {
            const data = {
              ...this.form
            };
            let res = await this.$apiFire("CalendarActivity/save", data);

            if(res.data && res.data != "undefined") {
              this.routeIndex();
            }else{
              this.routeBack();
            }
          }
        },
        setFormField(field, value) {
            this.form[field] = value;
            this.$forceUpdate();
        },
      routeBack() {
        this.$router.push({ name: 'CalendarActivity' })
      },
      routeIndex() {
        this.$router.push({
          name: 'CalendarActivity'
        })
      },
    }
}
</script>

<style scoped></style>